import React from 'react';
import { Route } from 'react-router';

import Health from '../../components/Pages/Health';

const routes = <Route path="health" component={Health.RootContainer}/>; // original

export default routes;



// WEBPACK FOOTER //
// ./src/routes/www/health.js